import { fetchWithHandling } from "../../utils/ApiUtils";


const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api/';


//get orders
export async function getOrders() {
    return await fetchWithHandling(`${BASE_URL}orders`, {
        credentials: 'include'
    });
}

// fetch pageable orders with optional filters: { page, size, q, status }
export async function getOrdersPage(params = {}) {
    const qs = Object.entries(params).filter(([,v])=>v!==undefined && v!==null && v!=='').map(([k,v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    const url = `${BASE_URL}orders${qs ? `?${qs}` : ''}`;
    return await fetchWithHandling(url, { credentials: 'include' });
}

    //Get order
export const getOrder = async (orderId) => {
    return await fetchWithHandling(`${BASE_URL}orders/${orderId}`, {
        credentials: 'include'
    });
    
}

// Get order by order number
export const getOrderByOrderNumber = async (orderNumber) => {
    return await fetchWithHandling(`${BASE_URL}orders/number/${encodeURIComponent(orderNumber)}`, {
        credentials: 'include'
    });
}

export const updateOrder = async (orderId, orderData) => {
    return await fetchWithHandling(`${BASE_URL}orders/${orderId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData),
        credentials: 'include'
    });
}


//Delete order
export async function deleteOrder(orderId) {
    return await fetchWithHandling(`${BASE_URL}orders/${orderId}`, {
        method: 'DELETE',
        credentials: 'include'
    });
}

//Create order
export async function createOrder(orderData) {
    return await fetchWithHandling(`${BASE_URL}orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData),
        credentials: 'include'
    });
}


//Get count by status
export async function getOrderCountByStatus() {
    return await fetchWithHandling(`${BASE_URL}orders/count-by-status`, {
        credentials: 'include'
    });
    
}


//Generate code
export async function generateCode(phoneData) {
    return await fetchWithHandling(`${BASE_URL}orders/generate-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(phoneData),
        credentials: 'include'
    });
}


export async function verifyCode(codeData) {
    if (process.env.REACT_APP_NODE_ENV !== 'production') console.log(codeData);
    return await fetchWithHandling(`${BASE_URL}orders/verify-code/${codeData.code}/${codeData.orderId}`, {
        credentials: 'include'
    });
}

export async function verifyDelivery(deliveryData) {
    return await fetchWithHandling(`${BASE_URL}orders/verify-delivery`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(deliveryData),
        credentials: 'include'
    });
}
